// extracted by css-extract-rspack-plugin
export default {"root":"nMkNqJ","icon":"UIpdTd"};